import React, { useState } from "react";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    // {
    //   question: "How can I boost my chances of getting selected for the program?",
    //   answer: (
    //     <>
    //       You can improve your chances of getting selected by actively contributing to
    //       the repositories of the participating organizations. Join the community on
    //       Discord, maintain your GitHub profile, and submit your contributions using{" "}
    //       <a href="#" style={{ color: "#b32a8c", textDecoration: "underline" }}>
    //         this sheet
    //       </a>{" "}
    //       and{" "}
    //       <a href="#" style={{ color: "#b32a8c", textDecoration: "underline" }}>
    //         this form
    //       </a>.
    //     </>
    //   ),
    // },
    {
      question: "Why should I apply to Code for GovTech's Dedicated Mentoring Program?",
      answer:
        "This program offers mentorship, real-world project experience, and opportunities to work on impactful open-source projects.",
    },
    {
      question: "How long is the Code for GovTech's Dedicated Mentoring Program?",
      answer: "The program runs for approximately 3 months, from June to August.",
    },
    {
      question:
        "How are contributors selected for Code for GovTech's Dedicated Mentoring Program?",
      answer:
        "Contributors are selected based on the quality and consistency of their open-source contributions and their engagement with the community.",
    },
    {
      question:
        "Is this the first time that Code for GovTech's Dedicated Mentoring Program is happening?",
      answer:
        "No, this program has been successfully conducted in previous years with many contributors benefiting from mentorship.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
     <style>{`
  .faq-section {
    width: 100%;
    background-color: #f8f9fc;
    padding: 60px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .faq-title {
    font-size: 35px;
    font-weight: 700;
    color: #222;
    margin-bottom: 40px;
    width: 100%;
    max-width: 1100px; /* Updated to match new container width */
    text-align: left;
    margin-left: 0; /* Removed the -200px offset for better centering */
  }

  .faq-container {
    width: 100%;
    max-width: 1100px; /* Increased from 900px to 1100px */
    padding-left: 20px;
    padding-right: 20px; /* Optional: for symmetry */
  }

  .faq-item {
    background: #fff;
    border: 1px solid #e2e2e2;
    margin-bottom: 10px;
    border-radius: 6px;
    overflow: hidden;
  }

  .faq-question {
    width: 100%;
    text-align: left;
    background-color: #fff;
    color: #222;
    font-size: 16px;
    font-weight: 600;
    padding: 16px 20px;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s ease;
  }

  .faq-question.active {
    background-color: #8b0c80;
    color: #fff;
  }

  .arrow {
    font-size: 18px;
    transition: transform 0.3s ease;
  }

  .arrow.open {
    transform: rotate(180deg);
  }

  .faq-answer {
    padding: 16px 20px;
    font-size: 15px;
    line-height: 1.6;
    color: #444;
    background: #fff;
    border-top: 1px solid #e2e2e2;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }

  /* ===== Full-width Impact Section (like footer) ===== */
  .impact-section {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    background: linear-gradient(90deg, #6a007e, #8b0c80);
    color: #fff;
    text-align: center;
    padding: 80px 20px;
    margin-top: 80px;
  }

  .impact-title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .impact-desc {
    font-size: 16px;
    margin-bottom: 30px;
    color: #eaeaea;
  }

  .apply-btn {
    background-color: #ffcb05;
    color: #222;
    font-weight: 600;
    border: none;
    border-radius: 6px;
    padding: 12px 32px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .apply-btn:hover {
    background-color: #f5b800;
  }

  @media (max-width: 768px) {
    .faq-title {
      font-size: 24px;
      margin-left: 0;
      text-align: center;
    }

    .impact-title {
      font-size: 22px;
    }

    .apply-btn {
      font-size: 15px;
    }
  }
`}</style>

      <section className="faq-section">
        <h2 className="faq-title">FAQs</h2>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span
                  className={`arrow ${activeIndex === index ? "open" : ""}`}
                >
                  ▼
                </span>
              </button>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="impact-section">
        <h3 className="impact-title">Ready to Make an Impact?</h3>
        <p className="impact-desc">
          Join the C4GT community to be notified when DMP 2026 applications open.
.
        </p>
        <button className="apply-btn">Join Community</button>
      </section>
    </>
  );
};

export default Faq;
